import { EMPTY_OBJECT } from 'commons-ui';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/homepageView/showView',
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
